import { render, staticRenderFns } from "./BankAccountIban.vue?vue&type=template&id=05ff291a&scoped=true"
import script from "./BankAccountIban.vue?vue&type=script&lang=js"
export * from "./BankAccountIban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff291a",
  null
  
)

export default component.exports